import { useTranslation } from 'react-i18next'

const normalizeContentItems = value => {
	if (!Array.isArray(value)) return []

	return value
		.map(item => {
			if (typeof item === 'string') return item.trim()
			return `${item?.name ?? item?.value ?? item?.label ?? ''}`.trim()
		})
		.filter(Boolean)
}

export default function TrainingContent({ content }) {
	const { t } = useTranslation()
	const contentItems = normalizeContentItems(content)

	return (
		<div className="rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<h2 className="text-sm font-semibold text-gray-900">{t('trainings.details.sections.content')}</h2>
			<div className="mt-4 flex flex-wrap gap-2">
				{contentItems.length ? contentItems.map(item => (
					<span
						key={item}
						className="inline-flex items-center rounded-full border border-gray-200 bg-gray-50 px-2.5 py-1 text-xs font-medium text-gray-700"
					>
						{item}
					</span>
				)) : (
					<span className="text-sm text-gray-500">{t('trainings.details.emptyContent')}</span>
				)}
			</div>
		</div>
	)
}
